// @flow

import React from 'react';
import AffluentSinglesAndCouples from '../DominantCustomerProfile/AffluentSinglesAndCouples';
import MiddleIncomeHomeOwningFamilies from '../DominantCustomerProfile/MiddleIncomeHomeOwningFamilies';
import LowerAffluenceFamilies from '../DominantCustomerProfile/LowerAffluenceFamilies';
import LowerAffluenceOldercommunities from '../DominantCustomerProfile/LowerAffluenceOlderCommunities';
import AffluentOlderCommunities from '../DominantCustomerProfile/AffluentOlderCommunities';
import AffluentYoungFamilies from '../DominantCustomerProfile/AffluentYoungFamilies';
import MiddleIncomeOlderEmptyNesters from '../DominantCustomerProfile/MiddleIncomeOlderEmptyNesters';
import MiddleIncomeSingles from '../DominantCustomerProfile/MiddleIncomeSingles';
import StudentLife from '../DominantCustomerProfile/StudentLife';
import type { CustomerProfileKpi, DominantCustomerProfileType } from '../../../../types/marketingType';
import Loader from '../../../common/Loader';
import { roundPercentage } from '../../../../utils/formatUtils';
import MarketingEmptyTile from './MarketingEmptyTile';
import LowerAffluenceSinglesAndCouples from '../DominantCustomerProfile/LowerAffluenceSinglesAndCouples';
import LowerAffluenceYoungsters from '../DominantCustomerProfile/LowerAffluenceYoungsters';

type Props = {
  dominantCustomerProfiles: DominantCustomerProfileType[],
  isLoading: boolean,
};

const profileType = {
  lowerAffluenceOlderCommunities: 'LOWER_AFFLUENCE_OLDER',
  studentLife: 'STUDENT_LIFE',
  lowerAffluenceFamilies: 'LOWER_AFFLUENCE_FAMILIES',
  lowerAffluenceYoungsters: 'LOWER_AFFLUENCE_YOUNGSTERS',
  lowerAffluenceSinglesAndCouples: 'LOWER_AFFLUENCE_SINGLES_AND_COUPLES',
  lowerAffluenceOlderAndRetirees: 'LOWER_AFFLUENCE_OLDER_AND_RETIREES',
  lowerAffluenceSingles: 'LOWER_AFFLUENCE_SINGLES',
  middleIncomeHomeOwningFamilies: 'MIDDLE_INCOME_HOME_OWNING_FAMILIES',
  middleIncomeOlderEmptyNesters: 'MIDDLE_INCOME_OLDER_EMPTY_NESTERS',
  middleIncomeSingles: 'MIDDLE_INCOME_SINGLES',
  middleIncomeOlder: 'MIDDLE_INCOME_OLDER',
  middleIncomeOlderAndRetiree: 'MIDDLE_INCOME_OLDER_AND_RETIREES',
  middleIncomeFamilies: 'MIDDLE_INCOME_FAMILIES',
  affluentSinglesAndCouples: 'AFFLUENT_SINGLES_AND_COUPLES',
  affluentOlderCommunities: 'AFFLUENT_OLDER',
  affluentYoungFamilies: 'AFFLUENT_YOUNG_FAMILIES',
  affluentEmptyNesters: 'AFFLUENT_EMPTY_NESTERS',
  affluentYoungProfessionals: 'AFFLUENT_YOUNG_PROFESSIONALS',
  mostAffluenceFamilies: 'MOST_AFFLUENT_FAMILIES',
  affluentHouseHold: 'AFFLUENT_HOUSEHOLD',
};

class DominantCustomerProfile extends React.Component<Props, State> {
  sortByValue = (kpi1: CustomerProfileKpi, kpi2: CustomerProfileKpi) => {
    if ((kpi1.value || '').length > (kpi2.value || '').length) {
      return -1;
    }
    if ((kpi1.value || '').length < (kpi2.value || '').length) {
      return 1;
    }
    return 0;
  };

  formatLabel = (label: string | null) => (label ? label.toUpperCase() : '-');

  formatValue = (value: string | null) => (value
    ? value.charAt(0).toUpperCase() + value.slice(1) : '-');

  getComponent = (dominantCustomerProfile: DominantCustomerProfileType): JSX.Element => {
    if (dominantCustomerProfile.type === profileType.affluentSinglesAndCouples
      || dominantCustomerProfile.type === profileType.affluentYoungProfessionals) {
      return (<AffluentSinglesAndCouples
        key={dominantCustomerProfile.type}
        title={dominantCustomerProfile.title}
        customerProfileKpis={
          (dominantCustomerProfile.customerProfileKpis || []).sort(this.sortByValue)
        }
        shoppingCenterCoverage={
          roundPercentage(dominantCustomerProfile.marketShareScCameoGroupHouseholds)
        }
        formatLabel={this.formatLabel}
        formatValue={this.formatValue}
      />);
    } else if (dominantCustomerProfile.type === profileType.affluentOlderCommunities
         || dominantCustomerProfile.type === profileType.affluentEmptyNesters) {
      return (<AffluentOlderCommunities
        key={dominantCustomerProfile.type}
        title={dominantCustomerProfile.title}
        customerProfileKpis={
          (dominantCustomerProfile.customerProfileKpis || []).sort(this.sortByValue)
        }
        shoppingCenterCoverage={
          roundPercentage(dominantCustomerProfile.marketShareScCameoGroupHouseholds)
        }
        formatLabel={this.formatLabel}
        formatValue={this.formatValue}
      />);
    } else if (dominantCustomerProfile.type === profileType.affluentYoungFamilies
      || dominantCustomerProfile.type === profileType.mostAffluenceFamilies
      || dominantCustomerProfile.type === profileType.affluentHouseHold) {
      return (<AffluentYoungFamilies
        key={dominantCustomerProfile.type}
        title={dominantCustomerProfile.title}
        customerProfileKpis={
          (dominantCustomerProfile.customerProfileKpis || []).sort(this.sortByValue)
        }
        shoppingCenterCoverage={
          roundPercentage(dominantCustomerProfile.marketShareScCameoGroupHouseholds)
        }
        formatLabel={this.formatLabel}
        formatValue={this.formatValue}
      />);
    } else if (dominantCustomerProfile.type === profileType.middleIncomeHomeOwningFamilies
      || dominantCustomerProfile.type === profileType.middleIncomeFamilies) {
      return (<MiddleIncomeHomeOwningFamilies
        key={dominantCustomerProfile.type}
        title={dominantCustomerProfile.title}
        customerProfileKpis={
          (dominantCustomerProfile.customerProfileKpis || []).sort(this.sortByValue)
        }
        shoppingCenterCoverage={
          roundPercentage(dominantCustomerProfile.marketShareScCameoGroupHouseholds)
        }
        formatLabel={this.formatLabel}
        formatValue={this.formatValue}
      />);
    } else if (dominantCustomerProfile.type === profileType.middleIncomeOlderEmptyNesters
      || dominantCustomerProfile.type === profileType.middleIncomeOlder
      || dominantCustomerProfile.type === profileType.middleIncomeOlderAndRetiree) {
      return (<MiddleIncomeOlderEmptyNesters
        key={dominantCustomerProfile.type}
        title={dominantCustomerProfile.title}
        customerProfileKpis={
          (dominantCustomerProfile.customerProfileKpis || []).sort(this.sortByValue)
        }
        shoppingCenterCoverage={
          roundPercentage(dominantCustomerProfile.marketShareScCameoGroupHouseholds)
        }
        formatLabel={this.formatLabel}
        formatValue={this.formatValue}
      />);
    } else if (dominantCustomerProfile.type === profileType.middleIncomeSingles) {
      return (<MiddleIncomeSingles
        key={dominantCustomerProfile.type}
        title={dominantCustomerProfile.title}
        customerProfileKpis={
          (dominantCustomerProfile.customerProfileKpis || []).sort(this.sortByValue)
        }
        shoppingCenterCoverage={
          roundPercentage(dominantCustomerProfile.marketShareScCameoGroupHouseholds)
        }
        formatLabel={this.formatLabel}
        formatValue={this.formatValue}
      />);
    } else if (dominantCustomerProfile.type === profileType.lowerAffluenceOlderCommunities
      || dominantCustomerProfile.type === profileType.lowerAffluenceOlderAndRetirees) {
      return (<LowerAffluenceOldercommunities
        key={dominantCustomerProfile.type}
        title={dominantCustomerProfile.title}
        customerProfileKpis={
          (dominantCustomerProfile.customerProfileKpis || []).sort(this.sortByValue)
        }
        shoppingCenterCoverage={
          roundPercentage(dominantCustomerProfile.marketShareScCameoGroupHouseholds)
        }
        formatLabel={this.formatLabel}
        formatValue={this.formatValue}
      />);
    } else if (dominantCustomerProfile.type === profileType.lowerAffluenceFamilies) {
      return (<LowerAffluenceFamilies
        key={dominantCustomerProfile.type}
        title={dominantCustomerProfile.title}
        customerProfileKpis={
          (dominantCustomerProfile.customerProfileKpis || []).sort(this.sortByValue)
        }
        shoppingCenterCoverage={
          roundPercentage(dominantCustomerProfile.marketShareScCameoGroupHouseholds)
        }
        formatLabel={this.formatLabel}
        formatValue={this.formatValue}
      />);
    } else if (dominantCustomerProfile.type === profileType.lowerAffluenceSinglesAndCouples
        || dominantCustomerProfile.type === profileType.lowerAffluenceSingles) {
      return (<LowerAffluenceSinglesAndCouples
        key={dominantCustomerProfile.type}
        title={dominantCustomerProfile.title}
        customerProfileKpis={
          (dominantCustomerProfile.customerProfileKpis || []).sort(this.sortByValue)
        }
        shoppingCenterCoverage={
          roundPercentage(dominantCustomerProfile.marketShareScCameoGroupHouseholds)
        }
        formatLabel={this.formatLabel}
        formatValue={this.formatValue}
      />);
    } else if (dominantCustomerProfile.type === profileType.lowerAffluenceYoungsters) {
      return (<LowerAffluenceYoungsters
        key={dominantCustomerProfile.type}
        title={dominantCustomerProfile.title}
        customerProfileKpis={
          (dominantCustomerProfile.customerProfileKpis || []).sort(this.sortByValue)
        }
        shoppingCenterCoverage={
          roundPercentage(dominantCustomerProfile.marketShareScCameoGroupHouseholds)
        }
        formatLabel={this.formatLabel}
        formatValue={this.formatValue}
      />);
    } else if (dominantCustomerProfile.type === profileType.studentLife) {
      return (<StudentLife
        key={dominantCustomerProfile.type}
        title={dominantCustomerProfile.title}
        customerProfileKpis={
          (dominantCustomerProfile.customerProfileKpis || []).sort(this.sortByValue)
        }
        shoppingCenterCoverage={
          roundPercentage(dominantCustomerProfile.marketShareScCameoGroupHouseholds)
        }
        formatLabel={this.formatLabel}
        formatValue={this.formatValue}
      />);
    }
    return (<AffluentSinglesAndCouples
      key={dominantCustomerProfile.type}
      title={dominantCustomerProfile.title}
      customerProfileKpis={
        (dominantCustomerProfile.customerProfileKpis || []).sort(this.sortByValue)
      }
      shoppingCenterCoverage={
        roundPercentage(dominantCustomerProfile.marketShareScCameoGroupHouseholds)
      }
      formatLabel={this.formatLabel}
      formatValue={this.formatValue}
    />);
  };

  render() {
    if (this.props.isLoading) {
      return (
        <div className="dominant-customer">
          <Loader isLoading />
        </div>
      );
    }
    if (!this.props.dominantCustomerProfiles || this.props.dominantCustomerProfiles.length === 0) {
      return (
        <MarketingEmptyTile errorMessage="MKT_PAGE.NO_DATA_CACI" />
      );
    }
    return (
      <div className="dominant-customer">
        {
          this.props.dominantCustomerProfiles.map(dominantCustomerProfile => (
            this.getComponent(dominantCustomerProfile)
          ))
        }
      </div>
    );
  }
}

export default DominantCustomerProfile;
